import * as React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Collapse } from 'reactstrap'
import classnames from 'classnames'
import { IconName, IconPrefix } from '@fortawesome/fontawesome'

export interface CollapsibleProps {
  icon: [IconPrefix, IconName]
  title: string
  isLoading?: boolean
  noGutters?: boolean
  defaultOpen?: boolean
}

export interface CollapsibleState {
  isCollapsed: boolean
  isCollapseElementOpen: boolean
}

class Collapsible extends React.PureComponent<CollapsibleProps, CollapsibleState> {
  constructor(props: CollapsibleProps) {
    super(props)

    this.state = {
      isCollapseElementOpen: false,
      isCollapsed: props.defaultOpen || false
    }
  }

  handleToggleCollapse = () => {
    this.setState((state) => ({ isCollapsed: !state.isCollapsed }))
  }

  handleEntering = () => {
    this.setState(() => ({ isCollapseElementOpen: true }))
  }

  handleExited = () => {
    this.setState(() => ({ isCollapseElementOpen: false }))
  }

  render() {
    const { isCollapsed, isCollapseElementOpen } = this.state
    const { children, icon, title, isLoading, noGutters } = this.props

    const loadingIcon: [IconPrefix, IconName] = ['fas', 'spinner']

    return (
      <div className="ggcollapsible mb-4">
        <button onClick={this.handleToggleCollapse} className={classnames('ggcollapsible-btn btn btn-block p-3 d-flex justify-content-between align-items-center', {
          'ggcollapsible-btn__open': (isCollapsed || isCollapseElementOpen),
        })}>
          <span className="d-flex align-items-center">
            <FontAwesomeIcon icon={loadingIcon as any} spin={isLoading} className="fas ggcollapsible-icon mr-3" />
            {title}
          </span>

          <FontAwesomeIcon icon={['fas', 'angle-down']} className={classnames('fas ggcollapsible-icon', {
            'ggcollapsible-icon__open': isCollapsed,
          })} />
        </button>

        <Collapse isOpen={isCollapsed} onEntering={this.handleEntering} onExited={this.handleExited}>
          <div className={classnames('ggcollapsible-content', {'p-3': !noGutters })}>
            {children}
          </div>
        </Collapse>
      </div>
    )
  }
}

export default Collapsible



// WEBPACK FOOTER //
// ./src/common/Collapsible.component.tsx